export const de = {
  common: {
    getInTouch: "Kontakt aufnehmen",
    requestQuote: "Angebot anfordern",
    inEuropeAndUK: "In Europa und Großbritannien",
  },
  nav: {
    about: "Über uns",
    services: "Dienstleistungen",
    fleet: "Flotte",
    contact: "Kontakt",
  },
  hero: {
    tagline: "Vertrauenswürdiger Transport- und Logistikpartner in Europa",
    deliveryTime: "Lieferzeit: 24-48 Stunden",
    features: {
      fastDelivery: {
        title: "Schnelle",
        description:
          "24-48 Stunden Lieferung in ganz Europa und Großbritannien",
      },
      tracking: {
        title: "Echtzeit-Verfolgung",
        description: "Verfolgen Sie Ihre Sendung in Echtzeit",
      },
      storage: {
        title: "Sicher",
        description: "Sichere Lagerlösungen",
      },
      partners: {
        title: "Vertrauenswürdige",
        description: "Zusammenarbeit mit Branchenführern",
      },
      experts: {
        title: "Experten",
        description: "Fachleute mit umfassender Erfahrung",
      },
    },
  },
  about: {
    title: "Wer wir sind",
    description:
      "Mit 30 Jahren Erfahrung im Transport- und Logistikbereich liefern wir vertrauenswürdige Fracht- und Versandlösungen in ganz Europa und Großbritannien. Mit Sitz in Arad, Rumänien, sind wir Ihr zuverlässiger Partner für nahtlose Logistik.",
    info: {
      location: {
        title: "Standort",
        description: "Arad, Rumänien",
      },
      experience: {
        title: "Erfahrung",
        description: "30+ Jahre im Transport",
      },
    },
    features: {
      reliability: {
        title: "Zuverlässigkeit",
        description:
          "Verlassen Sie sich auf unsere 30-jährige Erfahrung für zuverlässige Transportlösungen.",
      },
      efficiency: {
        title: "Effizienz",
        description:
          "Schnelle und effiziente Lieferung in ganz Europa und Großbritannien.",
      },
      safety: {
        title: "Sicherheit",
        description:
          "Ihre Fracht ist in sicheren Händen mit unserem erfahrenen Team.",
      },
      expertise: {
        title: "Expertise",
        description:
          "Professionelle Logistiklösungen, die auf Ihre Bedürfnisse zugeschnitten sind.",
      },
    },
  },
  services: {
    title: "Was wir tun",
    description:
      "Wir bieten umfassende Logistik-, Transport- und Lagerdienstleistungen für Unternehmen und Privatpersonen in ganz Europa und Großbritannien. Von Frachttransport bis hin zu sicherem Lagerraum gewährleisten wir eine effiziente und zuverlässige Lieferung.",
    road: {
      title: "Straßentransport",
      description:
        "Effiziente und zuverlässige Frachttransportdienste in ganz Europa und Großbritannien.",
    },
    express: {
      title: "Express-Lieferung",
      description:
        "Schnelle und sichere Lieferung für zeitkritische Sendungen.",
    },
    warehousing: {
      title: "Lagerlösungen",
      description: "Sichere Lagerstätten für Ihre Waren und Handelsgüter.",
    },
    international: {
      title: "Internationale Logistik",
      description:
        "Umfassende Logistiklösungen für internationale Lieferungen.",
    },
  },
  fleet: {
    title: "Unsere Flotte",
    description:
      "Unsere moderne Flotte entspricht der Euro-6-Norm und umfasst Fahrzeuge von 22 bis 40 Tonnen. Wir sind ausgestattet, um alle Ihre Transportanforderungen in ganz Europa und Großbritannien zu erfüllen.",
    euro6Compliant: "Euro-6-konforme Fahrzeuge",
    vehicles: {
      truck: {
        title: "Schwere Lkw",
        description: "Moderne Schwerlastfahrzeuge für den Fernverkehr.",
      },
      van: {
        title: "Lieferwagen",
        description:
          "Effiziente Transporter für lokale und regionale Lieferungen.",
      },
      trailer: {
        title: "Anhänger",
        description: "Vielseitige Anhänger für verschiedene Frachtarten.",
      },
      specialized: {
        title: "Spezialfahrzeuge",
        description:
          "Maßgeschneiderte Fahrzeuge für spezifische Transportanforderungen.",
      },
    },
    brands: {
      title: "Unsere Fahrzeugmarken",
    },
  },
  partners: {
    title: "Unsere Partner",
    description:
      "Wir arbeiten mit führenden Unternehmen aus verschiedenen Branchen zusammen, um umfassende Logistiklösungen anzubieten.",
    types: {
      manufacturing: {
        title: "Fertigung",
        description:
          "Unterstützung von Produktions- und Montagebetrieben mit zuverlässigen Transportlösungen.",
      },
      industrial: {
        title: "Industrie",
        description:
          "Versorgung von Schwerindustrien mit spezialisierten Transport- und Logistikdienstleistungen.",
      },
      retail: {
        title: "Einzelhandel",
        description:
          "Sicherstellung der pünktlichen Lieferung von Waren an Einzelhandelsstandorte in ganz Europa.",
      },
      logistics: {
        title: "Logistik",
        description:
          "Zusammenarbeit mit Logistikdienstleistern für End-to-End-Lieferkettenlösungen.",
      },
    },
    logos: {
      title: "Unsere vertrauenswürdigen Partner",
    },
  },
  perks: {
    title: "Warum uns wählen",
    description:
      "Genießen Sie Echtzeit-Tracking, zuverlässige Dienste und Express-Verteilung für nahtlosen Transport und Logistik in ganz Europa und Großbritannien. Wir legen Wert auf Effizienz und Kundenzufriedenheit.",
    items: {
      speed: {
        title: "Schnelle Lieferung",
        description:
          "24-48 Stunden Lieferung in ganz Europa und Großbritannien.",
      },
      safety: {
        title: "Sicherer Transport",
        description:
          "Ihre Fracht ist durch unsere umfassende Versicherung geschützt.",
      },
      coverage: {
        title: "Breite Abdeckung",
        description:
          "Umfangreiches Netzwerk in ganz Europa und Großbritannien.",
      },
      expertise: {
        title: "Expertenteam",
        description: "Professionelles Personal mit jahrelanger Erfahrung.",
      },
    },
  },
  quote: {
    title: "Angebot anfordern",
    description:
      "Zeit ist kostbar. Fordern Sie noch heute ein Angebot für schnelle und zuverlässige Transport- und Logistikdienste in ganz Europa und Großbritannien an.",
    button: "Angebot anfordern",
  },
  contact: {
    title: "Kontakt",
    description:
      "Kontaktieren Sie uns für professionelle Transport- und Logistikdienste in ganz Europa und Großbritannien.",
    phone: {
      title: "Telefon",
    },
    email: {
      title: "E-Mail",
    },
    address: {
      title: "Adresse",
    },
  },
  footer: {
    description:
      "Ihr vertrauenswürdiger Transport- und Logistikpartner in Europa und Großbritannien",
    contact: {
      title: "Kontakt",
    },
    quickLinks: {
      title: "Schnelllinks",
    },
    copyright: "Alle Rechte vorbehalten.",
  },
};
